module.exports = __webpack_public_path__ + "static/media/zolePlayed_100_250.ce8dd2b4.png";